<template>
	<div>
		<div v-if="config && config.tip" class="ipdtippc">{{config.tip}}</div>
		<div :style="'background-image:url('+(obj.img || '')+')'" class="uplodImg_01" >
			<div v-if="obj.type!=1 && obj.type!=2">
				<div class="uplodImg_03">
					<div style="font-size: 40px;margin: 50px auto;">+</div>
				</div>
			</div>
			<el-progress 
			v-if="obj.type==1"
			class="uplodImg_04" 
			:width="wid" 
			type="circle" 
			:percentage="obj.bfb"></el-progress>
			<video class="uplodImg_03cid" v-if="obj.img && /.mp4$/.test(obj.img)" :src="obj.img"></video>	
			<upload-file :config="config" v-model="obj" ref="upfile"></upload-file>
			
			<!-- v-else-if=""  -->
		</div>
	</div>
</template>
 
<script>

import uploadFile from './uploadFile2.vue';
export default {
	components:{uploadFile},
	props:{
		value:String,
		config:Object
	},
  	data () {
	    return {
			wid:100,
			obj:{
				type:0,
				bfb:0,
				img:'',
			}
	    }
  	},

	watch:{

		'obj.img'(){
			if(this.obj.img){
				this.$emit('input',this.obj.img)
			}

			
		},
		'value'(){

			if(this.value){
			
				this.$set(this.obj,'img',this.value)
				this.obj.type = 2;
			}
			
			
		}

	},

	mounted(){
		this.obj.img = this.value;
		if(this.value){
			this.obj.type = 2;
		}
	},
  	methods: {
      	push(file) {
			this.$refs.upfile.click();
      	},

	  },
}
</script>
<style lang="scss">
.uplodImg_01{
	position: relative;
	cursor: pointer;
	width: 128px;
	height: 128px;
	background: #FAFAFA;
	border: 1px dashed #D9D9D9;
	box-sizing: border-box;
	border-radius: 2px;
	background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}
.uplodImg_02{
	display: block;
	margin: 41px auto 0;
}
.uplodImg_03{
	color: rgba(0, 0, 0, 0.45);
	margin: 13px auto 0;
	text-align: center;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 22px;
}
.uplodImg_04{
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	width: 80%;
}
.ipdtippc{
	line-height: 40px;
    color: #828282;
}
.uplodImg_03cid{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>	